import { ErrorHandler, Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { flare } from '@flareapp/js';

@Injectable()
export class FlareErrorHandler implements ErrorHandler {
  private static readonly RELOAD_KEY = 'edm:chunk-reload-at';
  private static readonly RELOAD_THROTTLE_MS = 10_000;

  private static readonly CHUNK_ERROR_PATTERNS: RegExp[] = [
    /ChunkLoadError/i,
    /Loading chunk [\w-]+ failed/i,
    /Loading CSS chunk [\w-]+ failed/i,
    /Failed to fetch dynamically imported module/i,
    /error loading dynamically imported module/i,
  ];

  handleError(error: any): void {
    // Aba antiga tentando baixar um chunk lazy ja removido do S3 pelo deploy --delete.
    // Recarrega (com throttle anti-loop) para pegar a versao nova.
    if (this.isChunkLoadError(error) && this.canReload()) {
      this.markReload();
      window.location.reload();
      return;
    }

    const reported = error?.rejection ?? error?.originalError ?? error;
    if (reported instanceof HttpErrorResponse) {
      console.error(error);
      return;
    }
    try {
      flare.report(reported);
    } catch {}
    console.error(error);
  }

  private isChunkLoadError(error: unknown): boolean {
    const message = this.extractMessage(error);
    return FlareErrorHandler.CHUNK_ERROR_PATTERNS.some((p) => p.test(message));
  }

  private extractMessage(error: unknown): string {
    if (!error) return '';
    if (typeof error === 'string') return error;
    const c = error as { message?: string; rejection?: { message?: string } };
    return c.message || c.rejection?.message || String(error);
  }

  private canReload(): boolean {
    try {
      const last = Number(sessionStorage.getItem(FlareErrorHandler.RELOAD_KEY) || 0);
      return Date.now() - last > FlareErrorHandler.RELOAD_THROTTLE_MS;
    } catch {
      return true;
    }
  }

  private markReload(): void {
    try {
      sessionStorage.setItem(FlareErrorHandler.RELOAD_KEY, String(Date.now()));
    } catch {
      /* sessionStorage indisponivel */
    }
  }
}
